import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import getIframeId from './utils/getIframeId'
import CommunicatorClient from './CommunicatorClient'

const noop = () => {}

const WidgetSDKClient = ({ logger, appName, onDataReceive = noop }) => {
  const [widgetId] = useState(getIframeId(logger))
  useEffect(() => {
    document.documentElement.setAttribute('data-embedded', '')
  }, [])

  return widgetId ? (
    <CommunicatorClient logger={logger} widgetId={widgetId} appName={appName} onDataReceive={onDataReceive} />
  ) : null
}

WidgetSDKClient.propTypes = {
  onDataReceive: PropTypes.func,
  appName: PropTypes.string.isRequired,
  logger: PropTypes.shape({
    info: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired
  }).isRequired
}

export default WidgetSDKClient
